/**
 * Coordinate system and layout constants (docs/PHASE2_PLAN.md section 2.2).
 * Units are meters, Y is up, +X east, -Z north, +Z south. Placements are yaw-only.
 */
/** Height of one floor; same value as `FLOOR_HEIGHT` in `modules/org/src/layout.ts`. */
export const FLOOR_HEIGHT_M = 4;
/** The world extends this far from the origin in X and Z (v1: +-2 km). */
export const WORLD_EXTENT_M = 2000;
/** Default company parcel: 60 x 60 m. */
export const DEFAULT_PARCEL_SIZE_M = 60;
/** Roads between parcels. */
export const ROAD_GAP_M = 20;
/** Blueprint snapping: 1 m position grid, 15 degree yaw steps. */
export const SNAP_GRID_M = 1;
export const SNAP_YAW_DEG = 15;
/** Footprint of the seeded landmark hub at the origin. */
export const HUB_FOOTPRINT_M = { width: 24, depth: 24 };
export const HUB_FLOORS = 12;
export const degToRad = (deg) => (deg * Math.PI) / 180;
export const radToDeg = (rad) => (rad * 180) / Math.PI;
/** Yaw-only quaternion `[x, y, z, w]` for a rotation around +Y. */
export function yawToQuat(yawRad) {
    return [0, Math.sin(yawRad / 2), 0, Math.cos(yawRad / 2)];
}
/** Yaw of a yaw-only quaternion, or `null` when it has any pitch or roll (x or z not 0). */
export function quatToYaw(q) {
    const [x, y, z, w] = q;
    if (Math.abs(x) > 1e-9 || Math.abs(z) > 1e-9)
        return null;
    return 2 * Math.atan2(y, w);
}
/** Rounds `value` to a multiple of `step`. */
export function snap(value, step) {
    return Math.round(value / step) * step;
}
//# sourceMappingURL=constants.js.map